/*
 * @Author: mayanxia
 * @Date: 2022-05-07 08:43:16
 * @Last Modified by: mayanxia
 * @Last Modified time: 2023-11-10 11:52:08
 */

<template>
  <j-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    :bodyStyle="bodyStyle"
    :cancelText="$t('关闭')">
    <template slot="footer">
      <a-button key="close" @click="handleCancel">
        {{ $t('关闭') }}
      </a-button>
    </template>
    <a-spin :spinning="confirmLoading">
       <div class="form-contain" style="height: auto">
        <a-tabs v-model="activeKey" @change="changeTab">
          <a-tab-pane v-for="item in tabList" :key="item.key" :tab="item.title">
            <div v-if="activeKey == 1" style="height: calc(70vh - 90px);overflow-y: auto;">
              <detail-list :col="2" size="small">
                <detail-list-item :term="$t('设备编号')">{{model.meterId}}</detail-list-item>
                <detail-list-item :term="$t('上传时间')">{{model.collectTime}}</detail-list-item>
                <!-- <detail-list-item term="模组号">{{model.deviceId}}</detail-list-item> -->
                <detail-list-item :term="$t('SIM卡号')">{{model.meterSim}}</detail-list-item>
                <detail-list-item :term="$t('设备名称')">{{model.deviceName}}</detail-list-item>
                <detail-list-item :term="$t('安装位置')">{{model.deviceLocation}}</detail-list-item>

                <detail-list-item :term="$t('压力值(MPa)')">{{model.pvalue}}</detail-list-item>
                <detail-list-item :term="$t('温度(℃)')">{{model.tepvalue}}</detail-list-item>
                <detail-list-item :term="$t('总流量(m³)')">{{model.throughputTotal}}</detail-list-item>
                <detail-list-item :term="$t('正向流量(m³)')">{{model.throughput}}</detail-list-item>
                <!-- <detail-list-item term="反向流量(m³)">{{model.throughputMinus}}</detail-list-item> -->
                <detail-list-item :term="$t('瞬时流量(m³)')">{{model.flow}}</detail-list-item>
                <detail-list-item :term="$t('流速(m³/h)')">{{model.speed}}</detail-list-item>
                <detail-list-item :term="$t('软件版本号')">{{model.softVersion}}</detail-list-item>
                <detail-list-item :term="$t('仪表电池电压(%)')">{{model.batteryValue}}</detail-list-item>
                <detail-list-item :term="$t('GPRS电池电压(%)')">{{model.uv}}</detail-list-item>
              </detail-list>
            </div>
            <a-table
              v-else-if="activeKey != 1"
              ref="table"
              size="middle"
              :scroll="{y:'calc(70vh - 300px)',x:true}"
              bordered
              rowKey="id"
              :columns="columns"
              :dataSource="dataSource"
              :pagination="ipagination"
              :loading="loading"
              class="j-table-force-nowrap"
              @change="handleTableChange"
              >
            </a-table>
          </a-tab-pane>
        </a-tabs>
      </div>
    </a-spin>
  </j-modal>
</template>

<script>

  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  import {filterDictTextByCache} from '@/components/dict/JDictSelectUtil'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  export default {
    name: 'EmfFlowUpDataLastRecordModal',
    mixins:[JeecgListMixin],
    components: {
      DetailList,
      DetailListItem
    },
    data () {
      return {
        bodyStyle: {
          height: '60vh',
          'overflow-y': 'hidden'
        },
        width:800,
        visible: false,
        disableSubmit: false,
        model: {},
        confirmLoading: false,
        validatorRules: {
        },
        url: {
          add: "/jeecg-charge/wq/emfFlowUpDataLastRecord/add",
          edit: "/jeecg-charge/wq/emfFlowUpDataLastRecord/edit",
          queryById: "/jeecg-charge/wq/emfFlowUpDataLastRecord/queryById",
          list: "/jeecg-charge/wq/emfFlowUpDataRecord/list"
        },
        meterSignal: {},
        activeKey: 1,
        disableMixinCreated: true,
        uniqueParam: {},
      }
    },
    computed: {
      meterTypeName() {
        if(this.model.meterType) {
          let meterType = parseInt(this.model.meterType).toString(16)
          return  filterDictTextByCache('valve_device_type',meterType);
        }

      },
      // i18n：tab 使用 computed 以响应语言切换
      tabList() {
        return [
          {key: 1,title: this.$t('基本信息')},
          {key: 2,title: this.$t('历史数据')}
        ]
      },
      // i18n：表头使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('设备编号'),
            align:"center",
            dataIndex: 'meterId'
          },/*{
            title:'设备名称',
            align:"center",
            dataIndex: 'deviceName'
          },{
            title:'安装位置',
            align:"center",
            dataIndex: 'deviceLocation'
          },*/
          {
            title: this.$t('压力值(MPa)'),
            align:"center",
            dataIndex: 'pvalue'
          },
          {
            title: this.$t('温度值(℃)'),
            align:"center",
            dataIndex: 'tepvalue'
          },
          {
            title: this.$t('总累计流量(m³)'),
            align:"center",
            dataIndex: 'throughputTotal'
          },
          {
            title: this.$t('正向流量(m³)'),
            align:"center",
            dataIndex: 'throughput'
          },
          // {
          //   title:'反向流量(m³)',
          //   align:"center",
          //   dataIndex: 'throughputMinus'
          // },
          {
            title: this.$t('上报时间'),
            align:"center",
            dataIndex: 'collectTime'
          }
        ]
      },
    },
    created () {
    },
    methods: {
      close () {
        this.$emit('close');
        this.activeKey = 1;
        this.visible = false;
      },
      add () {
        this.edit({});
      },
      edit (record) {

        this.model = Object.assign({}, record);
        this.uniqueParam.deviceId = this.model.meterId
        this.visible = true;
      },
      handleOk () {
        const that = this;
      },
      handleCancel () {
        this.close()
      },
      changeTab() {
        if(this.activeKey == 2) {
          this.loadData(1)
        }
      }
    }
  }
</script>
<style scoped>
.detail-list >>> .term{
  line-height: 22px;
}
</style>
